<section class="chat-panel">
  <h2 class="chat-title"><mat-icon>forum</mat-icon> Chat with {{ agent.name }}</h2>

  <div #chatScroll class="chat-messages">
    @for (msg of agent.chatHistory; track msg.id) {
      <div class="chat-message" [class.from-user]="msg.role === 'user'">
        <div class="chat-bubble">
          <p class="chat-content">{{ msg.content }}</p>
          <span class="chat-time">{{ msg.timestamp | date: 'MMM d, HH:mm' }}</span>
        </div>
      </div>
    } @empty {
      <div class="chat-empty">
        <mat-icon>waving_hand</mat-icon>
        <p>Say hello to your teacher agent!</p>
      </div>
    }
  </div>

  <div class="chat-input-row">
    <textarea
      class="chat-input"
      placeholder="Ask your teacher anything..."
      rows="1"
      [(ngModel)]="messageText"
      (keydown)="onKeydown($event)"
    ></textarea>
    <button class="chat-send-btn" color="primary" mat-fab [disabled]="!messageText.trim()" (click)="send()">
      <mat-icon>send</mat-icon>
    </button>
  </div>
</section>
